module.exports = __webpack_public_path__ + "static/img/zhuanpan.1cb4196b.png";